//import { sampleData } from '../../app/api/sampleData';
import {
  CLEAR_APPLICATIONS,
  CREATE_APPLICATION,
  DELETE_APPLICATION,
  FETCH_AFFILIATE_LINK,
  FETCH_ALL_APPLICATIONS,
  FETCH_APPLICATIONS,
  FETCH_REVIEWS,
  LISTEN_TO_APPLICATION_PHOTOS,
  LISTEN_TO_SELECTED_APPLICATION,
  RETAIN_STATE,
  SET_LANGUAGE,
  SET_LEVEL,
  SET_MEDIA_TYPE,
  SET_SHOW_GENERIC,
  UPDATE_APPLICATION,
} from './libraryConstants';

const initialState = {
  applications: [],
  photos: [],
  reviews: [],
  moreApplications: true,
  selectedApplication: null,
  lastVisible: null,
  language: null,
  level: null,
  media_type: null,
  retainState: false,
  showGeneric: true,
};

export default function libraryReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case CREATE_APPLICATION:
      return {
        ...state,
        applications: [...state.applications, payload],
      };
    case UPDATE_APPLICATION:
      return {
        ...state,
        applications: [
          ...state.applications.filter((app) => app.id !== payload.id),
          payload,
        ],
      };
    case DELETE_APPLICATION:
      return {
        ...state,
        applications: [
          ...state.applications.filter((app) => app.id !== payload),
        ],
      };
    case FETCH_APPLICATIONS:
      return {
        ...state,
        applications: [...state.applications, ...payload.applications],
        moreApplications: payload.moreApplications,
        lastVisible: payload.lastVisible,
      };
    case FETCH_ALL_APPLICATIONS:
      return {
        ...state,
        applications: payload,
      };
    case LISTEN_TO_APPLICATION_PHOTOS:
      return {
        ...state,
        photos: payload,
      };
    case LISTEN_TO_SELECTED_APPLICATION:
      return {
        ...state,
        selectedApplication: payload,
      };
    case FETCH_REVIEWS:
      return {
        ...state,
        reviews: payload,
      };
    case CLEAR_APPLICATIONS:
      return {
        ...state,
        applications: [],
        moreApplications: true,
        lastVisible: null,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        retainState: false,
        moreApplications: true,
        language: payload,
      };
    case SET_LEVEL:
      return {
        ...state,
        retainState: false,
        moreApplications: true,
        level: payload,
      };
    case SET_MEDIA_TYPE:
      return {
        ...state,
        retainState: false,
        moreApplications: true,
        media_type: payload,
      };
    case SET_SHOW_GENERIC:
      return {
        ...state,
        retainState: false,
        moreApplications: true,
        showGeneric: payload,
      };
    case RETAIN_STATE:
      return {
        ...state,
        retainState: true,
      };
    case FETCH_AFFILIATE_LINK:
      return {
        ...state,
        redirect_url: payload,
      };
    default:
      return state;
  }
}
